// plugins/global-error-handler.js
if (process.client) {
  window.addEventListener('unhandledrejection', (event) => {
    console.error('Promise bị reject mà không được catch:', event.reason)
  })
}
